import axios from 'axios';
import EmployeeApportionment from '../entity/employee-apportionment';
import EmployeeApportionmentRequest from '../entity/employee-apportionment-request.entity';

export default class EmployeeApportionmentService {
  public static async getEmployeeApportionments(
    employeeId: string,
  ): Promise<EmployeeApportionment[]> {
    return axios.get(`/api/employee/${employeeId}/apportionment`)
      .then(({ data }) => data.map((item: any) => new EmployeeApportionment(item)));
  }

  public static async deleteEmployeeApportionment(
    employeeId: string,
    apportionmentId: string,
  ): Promise<void> {
    return axios.delete(`/api/employee/${employeeId}/apportionment/${apportionmentId}`);
  }

  public static async saveEmployeeApportionment(
    employeeId: string,
    apportionment: EmployeeApportionmentRequest[],
  ): Promise<EmployeeApportionment[]> {
    return axios.post(`/api/employee/${employeeId}/apportionment`, apportionment)
      .then(({ data }) => data.map((item: any) => new EmployeeApportionment(item)));
  }
}
